import { render, staticRenderFns } from "./page-views-card.vue?vue&type=template&id=87c6464c&scoped=true&"
import script from "./page-views-card.vue?vue&type=script&lang=js&"
export * from "./page-views-card.vue?vue&type=script&lang=js&"
import style0 from "./page-views-card.vue?vue&type=style&index=0&id=87c6464c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c6464c",
  null
  
)

export default component.exports